import {Property} from "./property";
import {Condition} from "./condition";
import {GridElementSubType} from "./grid-element-subtype";

export class GridElement { // TODO change to GridNode
  public gridElementId: number;
  public elementSubType: GridElementSubType;
  public properties: Array<Property> = new Array<Property>();
  public condition: Condition;

  constructor(gridElementId: number, elementSubType: GridElementSubType, properties: Array<Property>, condition: Condition) {
    this.gridElementId = gridElementId;
    this.elementSubType = elementSubType;
    this.properties = properties;
    this.condition = condition;
  }

  public getPropertyValue(propertyName: string): string {
    let propertyValue: string = "";

    this.properties.forEach((property: Property) => {
      if(property.name.toLowerCase() == propertyName.toLowerCase()){
        propertyValue = property.value;
        return;
      }
    });

    return propertyValue;
  }

  public getProperty(propertyName: string): boolean {
    let prop: boolean = false;
    this.properties.forEach((property: Property) => {
      if(property.name.toLowerCase() == propertyName.toLowerCase()){
        prop = true;
      }
    });
    return prop;
  }

  public setPropertyValue(propertyName: string, newPropertyValue): void {
    this.properties.forEach((property: Property) => {
      if(property.name.toLowerCase() == propertyName.toLowerCase()){
        property.value = newPropertyValue;
        return;
      }
    });
  }
}
